import * as React from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import ApiService from "../services/ApiService";
import getUser from "../services/decodeJWT";
import Nav from "../components/Nav";
import FamilyTreeComponent from "../components/FamilyTree";
import { useEffect, useState } from "react";
import { useCallback } from "react";

const CloneFamilyTree = () => {
  const { id } = useParams();

  const currentUser = getUser();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [cloneData, setCloneData] =useState(null);
  const [clonesList, setClonesList] = useState(null);

  const getClones = useCallback(async () => {
    try {
      setLoading(true);
      const response = await ApiService.get(`/cms/clones?limit=100&author=${currentUser?._id}`);
      setClonesList(response?.contents);
    } catch (err) {
      console.error("Error during fetching clones list:", err);
    } finally {
      setLoading(false);
    }
  }, [currentUser?._id]);

  const getClone = async () => {
    try {
      setLoading(true);
      const response = await ApiService.get(`/cms/clones?id=${id}`);
      if (response?.contents?.length > 0) {
        setCloneData(response.contents[0]);
      } else {
        console.warn("No clone data found.");
        setCloneData(null);
      }
    } catch (err) {
      console.error("Error during fetching clone data:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      getClone();
      getClones();
    }
  }, [id]);

  return (
    <div className="tyn-root">
      <Nav />
      <div className="tyn-content tyn-add-clone add-clone">
        <div className="tyn-main tyn-content-inner" id="tynMain">
          <div className="container">
            <div
              className="tyn-profile d-flex align-items-center justify-content-between px-5 py-4"
              style={{ background: "white", borderRadius: "1rem" }}
            >
              <div>
                <h3 className="text-center">
                  {cloneData?.data?.name
                    ? `${cloneData?.data?.name}'s Family tree`
                    : "Loading..."}
                </h3>
              </div>
              <div className="buttons d-flex">
                <Link className="btn btn-light" to={'/clone-list'} aria-label="Cancel and back to clone list">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-left" viewBox="0 0 16 16">
                    <path fillRule="evenodd" stroke="currentColor" strokeWidth="0.3" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8" />
                  </svg>
                  Clone List
                </Link>
              </div>
            </div>
            <div className="tyn-profile">
              <div className="tyn-profile-details mt-4">
                <div className="tab-content">
                  <div
                    className="tab-pane show active"
                    id="profile-edit"
                    tabIndex="0"
                  >
                    <div className="row gy-5">
                      <div className="col-12">
                        {loading ? (
                          <div className="spinner-container d-flex justify-content-center align-items-center">
                            <div
                              className="spinner-border"
                            >
                              <span className="visually-hidden">Loading...</span>
                            </div>
                          </div>
                        ) : (
                          <>
                            <FamilyTreeComponent
                              currentClone={cloneData}
                              clonesList={clonesList}
                            />
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>


  );
};

export default CloneFamilyTree;
